import { getToken } from '@/lib/token';
import { handleVersion } from '@/lib/version';
import { handlerRedirectUrlByLimitOpt } from '../lib/utils';
import { getUserInfo, getUserInfoByAuthCode } from '@/lib/auth';
import { updateRouter, hasUpdatedRouter } from './index';
const initRouter = (router) => {
  if (router) {
    router.beforeEach(async (to, from, next) => {
      to.query.limitOpt && sessionStorage.setItem('limitOpt', to.query.limitOpt);
      to.query.linghitScope && sessionStorage.setItem('linghitScope', to.query.linghitScope);

      const limitOpt = sessionStorage.getItem('limitOpt');
      const linghitScope = sessionStorage.getItem('linghitScope');

      // linghitScope为userinfo时，且链接带有authCode和app_id参数时，表示用户已授权，直接进入获取用户信息流程，跳过登录。(避免抢占登录)
      if (limitOpt && linghitScope === 'userinfo' && to.query.authCode && to.query.app_id) {
        const userInfo = await getUserInfoByAuthCode({
          code: to.query.authCode,
          app_id: to.query.app_id,
        });
        await handlerRedirectUrlByLimitOpt({ limitOpt: limitOpt, userInfo });
        sessionStorage.removeItem('limitOpt');
        sessionStorage.removeItem('linghitScope');
        return;
      }

      if (!getToken() && !['LOGIN', 'LOGINOLD', 'PHONE_LOGIN', 'LOGINV2'].includes(to.name)) {
        next('/loginV2');
      }

      if (getToken()) {
        const userInfo = await getUserInfo();
        if (limitOpt) {
          await handlerRedirectUrlByLimitOpt({ limitOpt: limitOpt, userInfo });
          sessionStorage.removeItem('limitOpt');
          return;
        }

        if (!hasUpdatedRouter) {
          updateRouter(userInfo);
          return next({
            path: to.path,
            replace: true,
          });
        }

        if (to.name === 'HOME' && handleVersion() !== '/') {
          next('/v2');
        } else if (to.name === 'HOME_V2' && handleVersion() !== '/v2') {
          next('/');
        }
      }
      next();
    });
  }
};

export default initRouter;
